import React, { useState, useEffect } from "react";
import EventHeader from "./EventHeader";
import ActionCard from "./EventActionCard";
import EventGallery from "./EventGallery";
import VerifyAccModal from "components/Modal/VerifyAccModal";
import { IFinalEvent } from "types/event";

import EventDescription from "./EventDescription";
import EventLocation from "./EventLocation";
import { useLang } from "hooks/useLang";
import useWindowSize from "hooks/useWindowSize";
import RenderVideo from "./f1/components/video/renderVideo";

interface Props {
  event: IFinalEvent;
  openVerificationModal: boolean;
  setOpenVerificationModal: React.Dispatch<React.SetStateAction<boolean>>;
  isExpiredEvent: boolean;
}

const EventContent: React.FC<Props> = ({
  event,

  openVerificationModal,
  setOpenVerificationModal,

  isExpiredEvent,
}) => {
  const { t } = useLang();
  const { isDesktop } = useWindowSize();
  const [showActionCard, setShowActionCard] = useState(false);
  const [isHeaderFixed, setIsHeaderFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!isDesktop) {
        setShowActionCard(true);
        setIsHeaderFixed(false);
        return;
      }
      const scrollPosition = window.scrollY;
      const showThreshold = 200; // Show card after scrolling 200px
      setShowActionCard(scrollPosition > showThreshold);
      setIsHeaderFixed(scrollPosition <= 50);
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isDesktop]);

  return (
    <>
      <div className="relative z-10">
        {/*-------- page content -------*/}
        <div
          className={`page-content flex flex-col gap-y-6 transition-all duration-300 ${
            !isHeaderFixed || !isDesktop
              ? "pt-0 pb-5"
              : "pt-[100px] mb-[10px] pb-[100px]"
          }`}
        >
          {/*-------- Header with position change and blur effect -------*/}

          <div
            className={`transition-all duration-300 ease-in-out ${
              isDesktop
                ? !isHeaderFixed
                  ? "relative shadow-lg"
                  : `w-full fixed bottom-0 max-w-[1200px]  border border-b-0 border-white border-opacity-20 backdrop-blur-sm
                              rounded-t-xl shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50
                            transition-all duration-300 ease-in-out transform translate-y-0 opacity-100`
                : "relative"
            }`}
          >
            <EventHeader event={event} />
          </div>

          <div className="sections-wrapper flex flex-col gap-y-4 mx-4 md:mx-0">
            <div className="section flex flex-col gap-y-1 lg:flex-row">
              <h6 className="lg:w-[20%] capitalize">{t("description")}</h6>
              <div className="lg:w-[60%]">
                <EventDescription event={event} />
              </div>
              <div className="lg:w-[20%]"></div>
            </div>
            {event.videos.length !== 0 && (
              <div className="section flex flex-col gap-y-1 lg:flex-row border-t border-t-white/20 lg:border-none py-4">
                <h6 className="lg:w-[20%] capitalize">{t("videos")}</h6>
                <div className="lg:w-[60%]">
                  <RenderVideo url={event.videos[0]} controls={true} />
                </div>
                <div className="lg:w-[20%]"></div>
              </div>
            )}

            <div className="section flex flex-col gap-y-1 lg:flex-row border-t border-t-white/20 lg:border-none py-4">
              <h6 className="lg:w-[20%] capitalize">{t("location")}</h6>
              <div className="lg:w-[60%]">
                <EventLocation event={event} />
              </div>
              <div className="lg:w-[20%]"></div>
            </div>
            <div className="section flex flex-col gap-y-1 lg:flex-row border-t border-t-white/20 lg:border-none py-4">
              <h6 className="lg:w-[20%] capitalize">{t("gallery")}</h6>
              <div className="lg:w-[60%]">
                <EventGallery event={event} />
              </div>
              <div className="lg:w-[20%]"></div>
            </div>
          </div>
        </div>

        <ActionCard
          verificationModalOpen={openVerificationModal}
          event={event}
          isExpired={isExpiredEvent}
          setOpenVerificationModal={setOpenVerificationModal}
          className={
            !showActionCard && isDesktop ? "translate-y-full opacity-0" : ""
          }
        />
      </div>

      {/*------ Booking Modal ------*/}

      {/*------ Verification Modal ------*/}
      <VerifyAccModal
        isModalOpen={openVerificationModal}
        setIsModalOpen={setOpenVerificationModal}
      />
    </>
  );
};

export default EventContent;
